@if ((!submitted && !editMode) || (!submitted && editMode && client)) {
  <div class="oauth2-client-edit-container">
    <div class="header">
      <h3>{{editMode ? 'Edit Client: ' + client.client_id : 'New Client'}}</h3>
      @if (editMode) {
        <button class="ui tiny button" (click)="navigateToServiceClient()">Service Client</button>
      }
    </div>
    <form novalidate class="ui form" [formGroup]="clientForm" (submit)="submit()"
      [ngClass]="{error: !clientForm.untouched && clientForm.invalid}">
      <div class="field">
        <label>allowed_cors_origins</label>
        <app-list-editor formControlName="allowed_cors_origins" hint="Your client origins, for example: https://example.com"></app-list-editor>
      </div>
      <div class="field">
        <label>audience</label>
        <app-list-editor formControlName="audience" hint="This will be aud claim of access token or ID token"></app-list-editor>
      </div>
      <div class="field">
        <label>redirect_uris</label>
        <app-list-editor formControlName="redirect_uris" hint="The URL where the Authorization Server will redirect the user after they grant permission."></app-list-editor>
      </div>
      <div class="field" [ngClass]="{error: clientForm.get('client_name')?.invalid && clientForm.get('client_name')?.touched}">
        <label>client_name</label>
        <input type="text" formControlName="client_name" placeholder="Provide a user friendly name">
      </div>
      <div class="field" [ngClass]="{error: clientForm.get('token_endpoint_auth_method')?.invalid && clientForm.get('token_endpoint_auth_method')?.touched}">
        <label>token_endpoint_auth_method</label>
        <app-single-select [selectList]="allowedTokenEndpointAuthMethods" formControlName="token_endpoint_auth_method"
        hint="Select a value"></app-single-select>
        <span class="hint-text">{{tokenEndpointHintText}}</span>
      </div>
      <div class="field" [ngClass]="{error: clientForm.get('grant_types')?.invalid && clientForm.get('grant_types')?.touched}">
        <label>grant_types</label>
        <app-multi-select [selectList]="allowedGrantTypes" formControlName="grant_types" hint="select multiple values"></app-multi-select>
      </div>
      @if (tokenEndpointAuthMethod === 'client_secret_basic' || tokenEndpointAuthMethod === 'client_secret_post') {
        <div class="field">
          <label>client_secret</label>
          <div class="ui action input">
            <input type="text" formControlName="client_secret" placeholder="A random secret is generated if leave empty.">
            <button class="ui teal right labeled icon button" (click)="generateSecret()">
              Generate
              <i class="sync icon"></i>
            </button>
          </div>
        </div>
      }
      <div class="field">
        <label>scope</label>
        <div class="ui message">
          <div class="content">Define the scope of your application, you should not ask scope exceed necessary needs. Here are predefined scopes</div>
          <ul class="list">
            <li><strong>offline_access</strong> include these if you want to get the refresh token</li>
            <li><strong>openid</strong> will grant application the id token</li>
            <li><strong>email</strong> will grant application to access the user's email</li>
            <li><strong>profile</strong> will grant application to access the user's name</li>
            <li><strong>bookmark</strong> will grant application to access the user's bookmarks and reviews</li>
          </ul>
        </div>
        <app-list-editor formControlName="scope"></app-list-editor>
      </div>
      <div class="field">
        <label>client_uri</label>
        <input type="text" formControlName="client_uri" placeholder="A URL string of a web page providing information about the client">
      </div>
      <div class="field">
        <label>contacts</label>
        <app-list-editor formControlName="contacts"></app-list-editor>
      </div>
      <div class="field">
        <label>logo_uri</label>
        <input type="text" formControlName="logo_uri">
      </div>
      <div class="field">
        <label>policy_uri</label>
        <input type="text" formControlName="policy_uri">
      </div>
      <div class="field">
        <label>tos_uri</label>
        <input type="text" formControlName="tos_uri">
      </div>
      <!--    <div class="field">-->
      <!--      <label>response_types</label>-->
      <!--      <app-list-editor formControlName="response_types"></app-list-editor>-->
    <!--    </div>-->
    <button class="ui primary button" type="submit">Submit</button>
    <button class="ui button" type="button" (click)="cancel()">Cancel</button>
  </form>
</div>
}
@if (submitted) {
  <div class="successful-container">
    <div class="ui success message">
      <div class="header">{{editMode ? 'Update' : 'Create'}} successfully</div>
      <div class="content">
        Your client {{client.client_name}} has been {{editMode ? 'Updated' : 'Created'}} successfully!
        Save your client_secret for later use.
      </div>
    </div>
    @if (client.client_secret) {
      <div class="ui info message">
        client_secret: {{client.client_secret}}
      </div>
    }
    <a class="ui button" routerLink="/settings/developer">Back to list</a>
    <div class="information">
      <pre>{{client | json}}</pre>
    </div>
  </div>
}
@if (!submitted && editMode && !client) {
  <div class="loading-container">
    <div class="ui placeholder">
      <div class="header">
        <div class="line"></div>
        <div class="line"></div>
      </div>
    </div>
    <div class="ui divider"></div>
    <div class="ui placeholder">
      <div class="paragraph">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <div class="paragraph">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <div class="paragraph">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
    </div>
  </div>
}
